import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { HomePage } from './components/HomePage';
import { BioPage } from './components/BioPage';
import { ContactPage } from './components/ContactPage';
import { EPKPage } from './components/EPKPage';
import { ShowsPage } from './components/ShowsPage';
import { MediaPage } from './components/MediaPage';
import { usePageTitle } from './hooks/usePageTitle';

const navLinks = [
    { to: '/', label: 'Home', page: 'home' },
    { to: '/band', label: 'Band', page: 'band' },
    { to: '/shows', label: 'Shows', page: 'shows' },
    { to: '/media', label: 'Media', page: 'media' },
    { to: '/contact', label: 'Contact', page: 'contact' },
    { to: '/epk', label: 'EPK', page: 'epk' },
];

export default function App() {
    const location = useLocation();
    const currentPage = navLinks.find((link) => link.to === location.pathname)?.page || 'home';

    // Update page title based on route
    usePageTitle();

    return (
        <div className="min-h-screen flex flex-col bg-background">
            {/* Header / Navigation */}
            <header className="bg-background border-b border-border">
                <div className="max-w-6xl mx-auto px-4 py-6">
                    <h1 className="text-center mb-4 text-primary text-2xl md:text-3xl font-bold tracking-wide">
                        SAMUEL JOHN BAND
                    </h1>
                    <nav className="flex justify-center gap-6 flex-wrap">
                        {navLinks.map(({ to, label, page }) => (
                            <Link
                                key={to}
                                to={to}
                                className={`uppercase tracking-wider text-sm transition-colors ${
                                    currentPage === page
                                        ? 'text-primary font-semibold'
                                        : 'text-foreground hover:text-primary'
                                }`}
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/band" element={<BioPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/epk" element={<EPKPage />} />
                    <Route path="/shows" element={<ShowsPage />} />
                    <Route path="/media" element={<MediaPage />} />
                </Routes>
            </main>

            {/* Footer */}
            <footer className="bg-card border-t border-border text-foreground text-center py-6 mt-12">
                <p className="text-sm text-muted-foreground">© 2026 Samuel John Band. All rights reserved.</p>
            </footer>
        </div>
    );
}
